import { useState, useEffect } from 'react';
import { Modal, Select, Input, Button } from '@bancobarigui/barihaus';
import { DisplayRule } from '../../types';
import { getConditionLabel, getConditionOptions } from '../utils/displayRuleLabels';

interface DisplayRuleModalProps {
  visible: boolean;
  onClose: () => void;
  onSave: (rule: DisplayRule) => void;
  currentRule?: DisplayRule | undefined;
}

export function DisplayRuleModal({ visible, onClose, onSave, currentRule }: DisplayRuleModalProps) {
  const [condition, setCondition] = useState<string>('equals');
  const [value, setValue] = useState<string>('');
  const [showError, setShowError] = useState<boolean>(false);

  useEffect(() => {
    if (currentRule) {
      setCondition(currentRule.condition);
      setValue(currentRule.value || '');
    } else {
      setCondition('equals');
      setValue('');
    }
    setShowError(false);
  }, [currentRule, visible]);

  const handleSave = () => {
    if (needsValue(condition) && !value.trim()) {
      setShowError(true);
      return;
    }

    onSave({
      condition,
      value: needsValue(condition) ? value as any : null,
      action: 'show',
    });
    onClose();
  };

  const needsValue = (cond: string) => {
    return !['isEmpty', 'isNotEmpty'].includes(cond);
  };

  const conditionOptions = getConditionOptions();

  return (
    <Modal
      title="Configurar Regra de Exibição"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancelar
        </Button>,
        <Button key="save" buttonColor="primary" onClick={handleSave}>
          Salvar
        </Button>,
      ]}
      width={600}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">Condição</label>
          <Select
            value={condition}
            onChange={setCondition}
            options={conditionOptions as any}
            className="w-full"
            placeholder="Selecione a condição"
          />
        </div>

        {needsValue(condition) && (
          <div>
            <label className="block text-sm font-medium mb-2">
              Valor para comparação *
            </label>
            <Input
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                if (showError && e.target.value.trim()) {
                  setShowError(false);
                }
              }}
              placeholder="Digite o valor..."
              status={showError && !value.trim() ? 'error' : ''}
            />
            {showError && !value.trim() && (
              <span className="text-xs text-red-500 mt-1">Este campo é obrigatório</span>
            )}
          </div>
        )}

        <div>
          <p className="text-blue-600">
            Se a resposta {getConditionLabel(condition)} {needsValue(condition) && value ? `"${value}"` : ''}, então mostrar esta questão.
          </p>
        </div>
      </div>
    </Modal>
  );
}
